export default {
  lang: {
    reset: 'Đặt lại',
    search: 'Sàng lọc',
    expand: 'Mở ra',
    collapse: 'Thu gọn',
  },
};
